import React from 'react';
export function SiteFooter() {
  return <footer className="w-full bg-pitch" data-id="element-189" data-mp="3rjvz5hlqcyja">
      <div className="mx-auto max-w-4xl px-5 py-14 text-center" data-id="element-190" data-mp="1bettc3zu76jg">
        <p className="text-lg font-extrabold text-white" data-id="element-191" data-mp="1bh6kn7rhit96">Método Fútbol Digital</p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-body" data-id="element-192" data-mp="1fh6wqlr42sd2">
          El sistema argentino para acompañar, proteger y potenciar la carrera futbolística de tu
          hijo.
        </p>
        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-body" data-id="element-193" data-mp="nrc8ytiwjaqi">
          <li data-id="element-194" data-mp="rp07e6jszln5">
            <a href="mailto:solucionesoinformacion@gmail.com" className="transition-colors duration-150 ease-out hover:text-brand-green" data-id="element-195" data-mp="roqikmahvkj1">
              📧 solucionesoinformacion@gmail.com
            </a>
          </li>
          <li data-id="element-196" data-mp="40qmd6uez1x2">
            <a href="https://instagram.com/metodofutboldigital" className="transition-colors duration-150 ease-out hover:text-brand-green" data-id="element-197" data-mp="418kya4jts85">
              📱 @metodofutboldigital
            </a>
          </li>
          <li data-id="element-198" data-mp="6l07xgdqfgr6">
            <a href="https://metodofutboldigital.shop" className="transition-colors duration-150 ease-out hover:text-brand-green" data-id="element-199" data-mp="6ml04zckqnlv">
              🌐 metodofutboldigital.shop
            </a>
          </li>
        </ul>
        <p className="mt-8 text-xs text-subtle" data-id="element-200" data-mp="3o206i8qd2b3l">
          Acceso digital inmediato · Material en PDF · Soporte por email
        </p>
        <p className="mt-3 text-xs text-subtle" data-id="element-201" data-mp="3j2nivlro0zzy">
          © 2026 Método para padres de futbolistas™ — Todos los derechos reservados
        </p>
      </div>
    </footer>;
}